<template>
  <div class="content">
    <h5-header :header-msg="headerMsg"></h5-header>
    <p></p>
    <div class="forms">
      <van-field
        v-model="message"
        rows="2"
        :autosize="{minHeight: 116}"
        type="textarea"
        maxlength="100"
        placeholder="请输入您要回复的内容"
        show-word-limit
        @input="inputs"
      />

      <span v-show="videoList.length>0">选择需要同步到评论中的录像</span>
      <van-checkbox-group v-model="result" :max="3" checked-color="#EC1911" @change="inputs">
        <van-checkbox :name="item.id" v-for="(item,index) in videoList" :key="index">
          <img :src="item.coverUrl" alt @click="playUrl(item.vodVideoId)" />
          <img src="../../assets/img/icon_evaluate_play.png" alt @click="playUrl(item.vodVideoId)" />
          <span>{{item.productName}}</span>
        </van-checkbox>
      </van-checkbox-group>
    </div>

    <!-- 视频播放弹窗页 -->
    <van-dialog v-model="showVideo" :showConfirmButton="false" :closeOnClickOverlay="true">
      <video :src="videosrc" controls="controls" width="100%" height="100%"></video>
    </van-dialog>

    <div class="btn_group">
      <van-button plain type="primary" color="#EC130C" @click="cancel()">取消</van-button>
      <van-button type="danger" color="#EC130C" @click="complaintProcess()" :disabled="disabled">回复</van-button>
    </div>
  </div>
</template>

<script>
import { complaintProcess, getOrderVideos, playUrl } from "@/api/picker/index";
export default {
  data() {
    return {
      headerMsg: {
        title: "投诉回复",
        url: "/complaintRecord"
      },
      videoList: [], //视频列表
      message: "",
      showVideo: false,
      videosrc: "", //视频src
      result: [], //视频复选框数组
      disabled: true
    };
  },
  mounted() {
    this.getOrderVideos(this.$route.query.oId);
  },
  methods: {
    complaintProcess() {
      let obj = {
        token: this.$store.getters.token || this.GetQueryString("token"),
        orderComplaintId: this.$route.query.id, // 订单投诉ID
        respondentProcessingResult: this.message, // 选菜师回复内容
        respondentProcessingVideoIdList: this.result // 选菜师选择的视频ID列表，没有为空表列表，最多3个
      };
      complaintProcess(obj).then(res => {
        if (res.appStatus.errorCode == 0) {
          //   this.detailObj = res.content;
          this.$toast("回复成功");
          setTimeout(() => {
            this.$router.push("/complaintRecord");
          }, 500);

          return;
        }
        this.$toast(res.appStatus.message);
      });
    },

    // 获取视频列表
    getOrderVideos(id) {
      let obj = {
        token: this.$store.getters.token || this.GetQueryString("token"),
        orderId: id //订单id
      };
      getOrderVideos(obj).then(res => {
        if (res.appStatus.errorCode == 0) {
          this.videoList = res.content.list;
          return;
        }
        this.$toast(res.appStatus.message);
      });
    },

    // 获取动态视频地址
    playUrl(id) {
      // console.log("2");
      let obj = {
        vodVideoId: id //点播服务中视频id，cfp_vod_video中的 vod_video_id
      };
      playUrl(obj).then(res => {
        this.showVideo = true;
        this.videosrc = res.content.playUrl;
      });
    },
    cancel() {
      this.$router.go(-1);
    },
    inputs(e) {
      // 文本框和视频集合分别处理
      if (e instanceof Array) {
        this.disabled =
          e.length > 0 ? false : this.message.length > 0 ? false : true;
        return;
      }
      this.disabled =
        e.length > 0 ? false : this.result.length > 0 ? false : true;
    }
    // changes(e) {
    //   // console.log(e)
    //   this.disabled = e.length > 0 ? false : true;
    // }
  }
};
</script>

<style lang="scss" scoped>
.content {
  //   height: 100%;
  overflow: hidden;
  > p {
    width: 100%;
    height: 5px;
    background: #f6f6f6;
    margin: 0;
  }
  .forms {
    // height: 100%;
    width: auto;
    padding: 10px;
    text-align: left;
    background: #fff;
    overflow: hidden;
    .van-cell {
      width: auto;
      padding: 10px;
      //   margin: 12px;
      background: #f6f6f6;
    }

    > span {
      font-size: 13px;
      color: #1d1d1d;
      display: block;
      margin: 15px 0;
    }
    /deep/.van-checkbox-group {
      width: auto;
      height: 436px;
      padding: 0 4px;
      .van-checkbox {
        width: auto;
        height: 45px;
        margin-top: 15px;
        .van-checkbox__label {
          height: 100%;
          display: flex;
          position: relative;
          img {
            width: 45px;
            height: 45px;
            position: absolute;
            left: 12px;
          }
          img:nth-child(1) {
            z-index: 98;
          }
          img:nth-child(2) {
            z-index: 99;
          }
          span {
            margin-left: 72px;
            font-size: 15px;
            color: #1d1d1d;
            font-weight: bold;
            height: 39px;
            line-height: 39px;
          }
        }
      }
    }
  }
  /deep/.btn_group {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-around;
    position: fixed;
    bottom: 10px;
    .van-button {
      width: 170px;
      height: 45px;
      line-height: 45px;
      border-radius: 5px;
    }
    .van-button--disabled {
      color: #999 !important;
      background: #EFEFEF !important;
      border-color: #EFEFEF !important;
    }
  }
  /deep/.van-dialog {
    background: none;
  }
}
</style>

